import { useState } from 'react';
import './PasswordInput.css';

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"/>
    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"/>
  </svg>
);

const PasswordInput = ({ className, style, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="pw-wrap">
      <input
        {...props}
        type={show ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '2.5rem', ...style }}
      />
      <button
        type="button"
        className="pw-wrap__eye"
        tabIndex={-1}
        onMouseDown={(e) => { e.preventDefault(); setShow(true); }}
        onMouseUp={() => setShow(false)}
        onMouseLeave={() => setShow(false)}
        aria-label="Show password"
      >
        <EyeIcon />
      </button>
    </div>
  );
};

export default PasswordInput;

